/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetExpenseRequest } from './AssetExpenseRequest';
import {
    AssetExpenseRequestFromJSON,
    AssetExpenseRequestFromJSONTyped,
    AssetExpenseRequestToJSON,
    AssetExpenseRequestToJSONTyped,
} from './AssetExpenseRequest';

/**
 * 
 * @export
 * @interface SaveAssetExpensesRequest
 */
export interface SaveAssetExpensesRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetExpensesRequest
     */
    hasIllnessExtraCosts: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof SaveAssetExpensesRequest
     */
    illnessExtraCostAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveAssetExpensesRequest
     */
    paysCostsAlone: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetExpensesRequest
     */
    costSharingExplanation: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetExpensesRequest
     */
    expenseRemarks: string | null;
    /**
     * 
     * @type {Array<AssetExpenseRequest>}
     * @memberof SaveAssetExpensesRequest
     */
    expenses: Array<AssetExpenseRequest>;
}

/**
 * Check if a given object implements the SaveAssetExpensesRequest interface.
 */
export function instanceOfSaveAssetExpensesRequest(value: object): value is SaveAssetExpensesRequest {
    if (!('hasIllnessExtraCosts' in value) || value['hasIllnessExtraCosts'] === undefined) return false;
    if (!('illnessExtraCostAmount' in value) || value['illnessExtraCostAmount'] === undefined) return false;
    if (!('paysCostsAlone' in value) || value['paysCostsAlone'] === undefined) return false;
    if (!('costSharingExplanation' in value) || value['costSharingExplanation'] === undefined) return false;
    if (!('expenseRemarks' in value) || value['expenseRemarks'] === undefined) return false;
    if (!('expenses' in value) || value['expenses'] === undefined) return false;
    return true;
}

export function SaveAssetExpensesRequestFromJSON(json: any): SaveAssetExpensesRequest {
    return SaveAssetExpensesRequestFromJSONTyped(json, false);
}

export function SaveAssetExpensesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetExpensesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hasIllnessExtraCosts': json['hasIllnessExtraCosts'],
        'illnessExtraCostAmount': json['illnessExtraCostAmount'],
        'paysCostsAlone': json['paysCostsAlone'],
        'costSharingExplanation': json['costSharingExplanation'],
        'expenseRemarks': json['expenseRemarks'],
        'expenses': ((json['expenses'] as Array<any>).map(AssetExpenseRequestFromJSON)),
    };
}

export function SaveAssetExpensesRequestToJSON(json: any): SaveAssetExpensesRequest {
    return SaveAssetExpensesRequestToJSONTyped(json, false);
}

export function SaveAssetExpensesRequestToJSONTyped(value?: SaveAssetExpensesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasIllnessExtraCosts': value['hasIllnessExtraCosts'],
        'illnessExtraCostAmount': value['illnessExtraCostAmount'],
        'paysCostsAlone': value['paysCostsAlone'],
        'costSharingExplanation': value['costSharingExplanation'],
        'expenseRemarks': value['expenseRemarks'],
        'expenses': ((value['expenses'] as Array<any>).map(AssetExpenseRequestToJSON)),
    };
}

